// extracted by mini-css-extract-plugin
export default {"alertRoot":"alert_alertRoot__Ul9tS"};